// extracted by mini-css-extract-plugin
export default {"container":"NewsGrid_container__JN1Li"};